import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FirstStageQueryVariables = Types.Exact<{
  extensionId: Types.Scalars['Int']['input'];
}>;


export type FirstStageQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, numberId: number, displayName: string, mobileNumber: string, homeNumber: string, notificationEmail?: string | null, pin: string, alternateCallerNumberId?: number | null, locationId: number, alias?: string | null, featuresRestrictions: Array<Types.FeatureRestriction | null>, secretaryNumberId?: number | null, previewFeaturesEnabled: boolean, cliro: boolean, connectedNumberPresentationRestrictionOverride: boolean, nationalCac: string, internationalCac: string, callLimit: number, directInwardDialing: boolean, directOutwardDialing: boolean, recordingType: Types.DirectionType, privateRoutingType?: Types.PrivateRoutingType | null, outgoingCallBarringUser?: any | null, outgoingCallBarringAdmin?: any | null, outgoingCallBarringOperator?: any | null, callWaiting: boolean, maliciousCallTrace: boolean, voicemailToEmailEnabled: boolean, hotnumber?: string | null, number?: { __typename?: 'Number', nonPaymentBlockingType: Types.NonPaymentBlockingType, callOriginationDenied: boolean, callTerminationDenied: boolean, shortNumber?: string | null, domain: { __typename?: 'Domain', domainType: Types.DomainType, name: string, id: number } } | null, location?: { __typename?: 'Location', name: string } | null } | null> } | null };

export type SecondStageQueryVariables = Types.Exact<{
  numberId: Types.Scalars['Int']['input'];
  domainId: Types.Scalars['Int']['input'];
}>;


export type SecondStageQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, name: string } | null> } | null, locations?: { __typename?: 'LocationList', items: Array<{ __typename?: 'Location', id: number, name: string, pilotNumber: string } | null> } | null, overrideNumbers?: Array<{ __typename?: 'ReplaceOption', numberId: number, name: string, e164: any, numberType: Types.NumberType } | null> | null, secretaryNumbers?: Array<{ __typename?: 'ReplaceOption', numberId: number, name: string } | null> | null };

export type UserEmailsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserEmailsQuery = { __typename?: 'Query', userEmails?: Array<string | null> | null };


export const FirstStageDocument = gql`
    query FirstStage($extensionId: Int!) {
  users(id: $extensionId) {
    items {
      id
      number {
        nonPaymentBlockingType
        callOriginationDenied
        callTerminationDenied
        shortNumber
        domain {
          domainType
          name
          id
        }
      }
      numberId
      displayName
      mobileNumber
      homeNumber
      notificationEmail
      pin
      alternateCallerNumberId
      locationId
      location {
        name
      }
      alias
      featuresRestrictions
      secretaryNumberId
      previewFeaturesEnabled
      cliro
      connectedNumberPresentationRestrictionOverride
      nationalCac
      internationalCac
      callLimit
      directInwardDialing
      directOutwardDialing
      recordingType
      privateRoutingType
      outgoingCallBarringUser
      outgoingCallBarringAdmin
      outgoingCallBarringOperator
      callWaiting
      maliciousCallTrace
      voicemailToEmailEnabled
      hotnumber
    }
  }
}
    `;

/**
 * __useFirstStageQuery__
 *
 * To run a query within a React component, call `useFirstStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirstStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirstStageQuery({
 *   variables: {
 *      extensionId: // value for 'extensionId'
 *   },
 * });
 */
export function useFirstStageQuery(baseOptions: Apollo.QueryHookOptions<FirstStageQuery, FirstStageQueryVariables> & ({ variables: FirstStageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirstStageQuery, FirstStageQueryVariables>(FirstStageDocument, options);
      }
export function useFirstStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirstStageQuery, FirstStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirstStageQuery, FirstStageQueryVariables>(FirstStageDocument, options);
        }
export function useFirstStageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FirstStageQuery, FirstStageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FirstStageQuery, FirstStageQueryVariables>(FirstStageDocument, options);
        }
export type FirstStageQueryHookResult = ReturnType<typeof useFirstStageQuery>;
export type FirstStageLazyQueryHookResult = ReturnType<typeof useFirstStageLazyQuery>;
export type FirstStageSuspenseQueryHookResult = ReturnType<typeof useFirstStageSuspenseQuery>;
export type FirstStageQueryResult = Apollo.QueryResult<FirstStageQuery, FirstStageQueryVariables>;
export const SecondStageDocument = gql`
    query SecondStage($numberId: Int!, $domainId: Int!) {
  groups(domainId: $domainId, memberNumberId: $numberId) {
    items {
      id
      name
    }
  }
  locations(domainId: $domainId) {
    items {
      id
      name
      pilotNumber
    }
  }
  overrideNumbers: replaceNumberOptions(
    numberId: $numberId
    numberTypes: [EXTENSION, IVR, GROUP, FAX, GATEWAY]
    e164Only: true
  ) {
    numberId
    name
    e164
    numberType
  }
  secretaryNumbers: replaceNumberOptions(
    numberId: $numberId
    numberTypes: [EXTENSION]
  ) {
    numberId
    name
  }
}
    `;

/**
 * __useSecondStageQuery__
 *
 * To run a query within a React component, call `useSecondStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecondStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecondStageQuery({
 *   variables: {
 *      numberId: // value for 'numberId'
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useSecondStageQuery(baseOptions: Apollo.QueryHookOptions<SecondStageQuery, SecondStageQueryVariables> & ({ variables: SecondStageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SecondStageQuery, SecondStageQueryVariables>(SecondStageDocument, options);
      }
export function useSecondStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SecondStageQuery, SecondStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SecondStageQuery, SecondStageQueryVariables>(SecondStageDocument, options);
        }
export function useSecondStageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SecondStageQuery, SecondStageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SecondStageQuery, SecondStageQueryVariables>(SecondStageDocument, options);
        }
export type SecondStageQueryHookResult = ReturnType<typeof useSecondStageQuery>;
export type SecondStageLazyQueryHookResult = ReturnType<typeof useSecondStageLazyQuery>;
export type SecondStageSuspenseQueryHookResult = ReturnType<typeof useSecondStageSuspenseQuery>;
export type SecondStageQueryResult = Apollo.QueryResult<SecondStageQuery, SecondStageQueryVariables>;
export const UserEmailsDocument = gql`
    query UserEmails {
  userEmails
}
    `;

/**
 * __useUserEmailsQuery__
 *
 * To run a query within a React component, call `useUserEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEmailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserEmailsQuery(baseOptions?: Apollo.QueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEmailsQuery, UserEmailsQueryVariables>(UserEmailsDocument, options);
      }
export function useUserEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEmailsQuery, UserEmailsQueryVariables>(UserEmailsDocument, options);
        }
export function useUserEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserEmailsQuery, UserEmailsQueryVariables>(UserEmailsDocument, options);
        }
export type UserEmailsQueryHookResult = ReturnType<typeof useUserEmailsQuery>;
export type UserEmailsLazyQueryHookResult = ReturnType<typeof useUserEmailsLazyQuery>;
export type UserEmailsSuspenseQueryHookResult = ReturnType<typeof useUserEmailsSuspenseQuery>;
export type UserEmailsQueryResult = Apollo.QueryResult<UserEmailsQuery, UserEmailsQueryVariables>;